// Admin reactions on their messages (wa_reply with kind "reaction"). Same four as functions/wa/logic.REACTIONS.
import type { ThreadMessage } from "@/data/types";

export const REACTIONS = ["🙏", "😊", "❤️", "👍"] as const;

/** Only their messages, and not their own reactions (WhatsApp can't react to a reaction). */
export function canReact(m: ThreadMessage): boolean {
  return m.dir === "in" && m.kind !== "reaction";
}

/** Picking the emoji we already sent removes it ("" = clear), like WhatsApp. */
export function nextReaction(current: string | null, picked: string): string {
  return current === picked ? "" : picked;
}

/** Our sent reactions show on the target bubble, not as bubbles of their own. */
export function threadBubbles(msgs: ThreadMessage[]): ThreadMessage[] {
  return msgs.filter((m) => !(m.dir === "out" && m.kind === "reaction"));
}
